// Abstract away the awful JavaScript for creating an array of a given size and mapping over it
export const times = <T>(n: number, fn: (i: number) => T): T[] =>
    Array.apply(null, Array(n)).map((_: null, i: number) => fn(i))
;



// WEBPACK FOOTER //
// ./src/util/times.ts